<script setup lang="ts">
import { ref } from 'vue'

const emit = defineEmits<{
  (e: 'files', files: FileList): void
}>()

const props = defineProps<{
  accept?: string
  multiple?: boolean
}>()

const input = ref<HTMLInputElement | null>(null)

function onChange(event: Event) {
  if (event.target instanceof HTMLInputElement && event.target.files) {
    emit('files', event.target.files)
  }
}

function upload() {
  input.value?.click()
}

defineExpose({ upload })
</script>

<template>
  <input
    ref="input"
    type="file"
    class="hidden"
    :accept="props.accept"
    :multiple="props.multiple"
    @change="onChange"
  />
  <slot :upload="upload" />
</template>
